import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../hierarchyAssignmentsPanelTab/reducerGenerator'
import {CLOSE_ALL_PANELS} from '../common/actionTypes'

const hierarchyAssignmentsPanelReducer = reducerGenerator({
    actionTypes: ActionTypes
})

const initialState = {
    ...hierarchyAssignmentsPanelReducer.initialState,
    copyContent: {
        userId: null,
        loading: false,
        counters: {
            task: 0,
            project: 0,
            customer: 0,
        },
        isAllScopeToCopyUserFrom: false,
        selectedOption: null,
        viewerHasEntireScope: true,

        usersForSelector: [],
    },
    showCopyContent: false,
    assignAllScopeContent: {
        loading: false,
        show: false,
    },
    noCptAssignedToUserAtAll: false,
}

const workAssignmentsPanel = handleActions({
    ...hierarchyAssignmentsPanelReducer.handlers,
    [ActionTypes.SHOW_COPY_SET]: (state, {payload: show}) => ({
        ...state,
        showCopyContent: show,
    }),
    [ActionTypes.COPY_USER_ID_SET]: (state, {payload: userId}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            userId,
        }
    }),
    [ActionTypes.COPY_VIEWER_HAS_ENTIRE_SCOPE_SET]: (state, {payload: viewerHasEntireScope}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            viewerHasEntireScope,
        }
    }),
    [ActionTypes.COPY_LOADING_SET]: (state, {payload: loading}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            loading,
        }
    }),
    [ActionTypes.COPY_ALL_SCOPE_SET]: (state, {payload: isAllScopeToCopyUserFrom}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            isAllScopeToCopyUserFrom,
        }
    }),
    [ActionTypes.COPY_COUNTERS_SET]: (state, {payload: counters}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            counters,
        }
    }),
    [ActionTypes.COPY_OPTION_SET]: (state, {payload: option}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            selectedOption: option,
        }
    }),
    [ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET]: (state, {payload: usersForSelector}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            usersForSelector,
        }
    }),
    [ActionTypes.COPY_CONTENT_OPEN] : (state) => ({
        ...state,
        copyContent: {
            userId: null,
            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0,
            },
            usersForSelector: [],
            selectedOption: null,
            isAllScopeToCopyUserFrom: false,
            viewerHasEntireScope: true,
        },
        showCopyContent: true,
    }),
    [ActionTypes.COPY_CONTENT_CLOSE] : (state) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            userId: null,
            selectedOption: null,
        },
        showCopyContent: false,
    }),
    [ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_OPEN] : (state) => ({
        ...state,
        assignAllScopeContent: {
            loading: false,
            show: true,
        },
    }),
    [ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_CLOSE] : (state) => ({
        ...state,
        assignAllScopeContent: {
            ...state.assignAllScopeContent,
            show: false,
        },
    }),
    [ActionTypes.USER_HAVE_NO_CPT_AT_ALL_SET]: (state, {payload: noCptAssignedToUserAtAll}) => ({
        ...state,
        noCptAssignedToUserAtAll: noCptAssignedToUserAtAll,
    }),
    [CLOSE_ALL_PANELS]: (state) => {
        return ({
            ...state,
            userId: null,
            tab: null,
            copyContent: {
                userId: null,
                loading: false,
                counters: {
                    task: 0,
                    project: 0,
                    customer: 0,
                },
                isAllScopeToCopyUserFrom: false,
                selectedOption: null,
                viewerHasEntireScope: true,

                usersForSelector: [],
            },
            showCopyContent: false,
            assignAllScopeContent: {
                loading: false,
                show: false,
            },
            noCptAssignedToUserAtAll: false,
        })
    },
}, initialState)
export default workAssignmentsPanel


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/reducer.js